/* eslint-disable camelcase */
import React from 'react';
import { Column } from 'react-table';
import { Box, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { ColumnFilter, GlobalFilter } from '../shared/material_components';
import { SystemTypeEnum } from './types';
import { SqlOptions } from '../tasks/types';

interface Props {
  formData: SqlOptions;
  columns: Column[];
  callback: (filter: Record<string, any>[]) => void;
  type: SystemTypeEnum;
  resetFilters: boolean;
}

const defaultFiltersTask = [
  {
    key: 'date_filter',
    field: 'Date Filter',
    label: 'Date Filter: All Time',
    values: [
      {
        label: 'All Time',
        value: 'All Time',
      },
    ],
  },
];

const defaultFiltersIssue = [
  {
    key: 'date_filter',
    field: 'Date Filter',
    label: 'Date Filter: All Time',
    values: [
      {
        label: 'All Time',
        value: 'All Time',
      },
    ],
  },
  {
    key: 'status',
    field: 'Status',
    label: 'Status: Needs resolution',
    values: [
      {
        label: 'Needs resolution',
        value: 'Needs resolution',
      },
    ],
  },
];

export const defaultFilters: Record<SystemTypeEnum, any> = {
  basic_task: defaultFiltersTask,
  basic_issue: defaultFiltersIssue,
};

const Filters: React.FC<Props> = ({
  columns, formData, callback, type, resetFilters,
}) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
      <Box sx={{ width: isMobile ? '100%' : 300 }} mr={0.5} mb={0.5}>
        <GlobalFilter
          form={formData.restForm}
          // @ts-ignore
          setGlobalFilter={(e) => callback(e)}
          resetFilter={resetFilters}
        />
      </Box>
      <ColumnFilter
        formData={formData}
        columns={columns}
        callback={(e) => callback(e)}
        type={type}
        resetFilters={resetFilters}
      />
    </Box>
  );
};

export default React.memo(Filters);
